import { render } from "./Graficos.vue?vue&type=template&id=28bcb839&scoped=true"
import script from "./Graficos.vue?vue&type=script&lang=js"
export * from "./Graficos.vue?vue&type=script&lang=js"

import "./Graficos.vue?vue&type=style&index=0&id=28bcb839&scoped=true&lang=css"

import exportComponent from "/home/runner/work/alperlab/alperlab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28bcb839"]])

export default __exports__